const GUEST_DOMAIN = import.meta.env.VITE_GUEST_DOMAIN;
const HOST_DOMAIN = import.meta.env.VITE_HOST_DOMAIN;

export function getHotelTopUrl(hotelID: string) {
	return `${GUEST_DOMAIN}/${hotelID}`;
}

export function getHotelTopAboutUrl(hotelID: string) {
	return `${GUEST_DOMAIN}/${hotelID}#hotelMenu`;
}

export function getHotelStudioTopUrl(hotelID: string) {
	return `${GUEST_DOMAIN}/${hotelID}/studio`;
}

export function getHotelDetailUrl(hotelID: string) {
	return `${GUEST_DOMAIN}/${hotelID}/detail`;
}

export function getPlanDetailUrl(hotelID: string, planID: string) {
	return `${GUEST_DOMAIN}/${hotelID}/plan/${planID}`;
}

export function getRoomDetailUrl(hotelID: string, roomID: string) {
	return `${GUEST_DOMAIN}/${hotelID}/room/${roomID}`;
}

export function getGiftDetailUrl(hotelID: string, giftID: string) {
	return `${GUEST_DOMAIN}/${hotelID}/campaign/${giftID}`;
}

// 管理画面
export function getReservationDetail(hotelID: string, reservationID: string) {
	return `${HOST_DOMAIN}/${hotelID}/management/reservation/${reservationID}`;
}

export function getDiscountSupport(hotelID: string) {
	return `${HOST_DOMAIN}/${hotelID}/items/discounts/support`;
}
